import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.image.alt.attribute': {
    id: 'profile.image.alt.attribute',
    defaultMessage: 'profile avatar',
    description: 'Alt attribute for a profile photo',
  },
  'profile.profileavatar.change-button': {
    id: 'profile.profileavatar.change-button',
    defaultMessage: 'Change',
    description: 'Change photo button',
  },
});

export default messages;
